import request from '@/axios'
import type { UserType, UserLoginType, LoginResponse, GoogleLoginResponse } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserLoginType): Promise<IResponse<LoginResponse>> => {
  return request.post({ url: '/api/login', data })
}

/** Google Identity Services ID token; uses the admin-only OAuth client (system config `google_oauth_admin`). */
export const googleLoginApi = (data: {
  credential: string
}): Promise<IResponse<GoogleLoginResponse>> => {
  return request.post({ url: '/api/auth/google-admin', data })
}

// Self-registration removed: admin accounts are created by an existing
// super_admin via the admin /users page (POST /api/admin/users), never by a
// public form. The frontend RegisterForm.vue was deleted.

// ── Forgot-password flow ───────────────────────────────────────────────────
// Same OTP infrastructure as the customer portal, but routed through the
// admin namespace so an account that exists in both portals doesn't have its
// reset codes collide.
export interface ForgotPasswordSendCodeBody {
  contact: string
  contact_type: 'email' | 'phone'
}
export interface ForgotPasswordResetBody extends ForgotPasswordSendCodeBody {
  code: string
  new_password: string
}
export const adminForgotPasswordSendCodeApi = (
  data: ForgotPasswordSendCodeBody
): Promise<IResponse<{ expires_in: number }>> => {
  return request.post({ url: '/api/admin/auth/forgot-password/send-code', data })
}
export const adminForgotPasswordResetApi = (
  data: ForgotPasswordResetBody
): Promise<
  IResponse<{
    access_token: string
    token_type: string
    expires_in: number
    user: { id: string; username: string; email: string | null; roles: string[] }
  }>
> => {
  return request.post({ url: '/api/admin/auth/forgot-password/reset', data })
}

export const changePasswordApi = (data: { new_password: string }): Promise<IResponse> => {
  return request.post({ url: '/api/me/change-password', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/api/logout' })
}

export const getUserInfoApi = (): Promise<IResponse<UserType>> => {
  return request.get({ url: '/api/me' })
}

/** Update current user profile (email, phone). Used by 个人信息. */
export const updateProfileApi = (data: {
  email?: string
  phone?: string
}): Promise<IResponse<UserType>> => {
  return request.patch({ url: '/api/me', data })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
